/**
 * Pure validity rules for an editable answer-options list (SINGLE_SELECT /
 * MULTI_SELECT). Lives in the domain layer — NOT in the OptionsEditor UI
 * component — so both the editor's inline hint and any caller-side gate (e.g.
 * the AuditWhiz publish validator) share one source of truth without the
 * domain layer depending on a React/Stencil module.
 *
 * Pure — no react, no side effects.
 */

/** A select-type needs at least two distinct choices to be meaningful. The
 *  domain validator and the editor's inline hint gate on this same threshold. */
export const MIN_OPTIONS = 2;

/** Count of non-blank (trimmed) options — the measure the min-options hint and
 *  any caller-side validity gate must share (see the derived-display steering). */
export function countNonEmptyOptions(options: readonly string[]): number {
  return options.filter((opt) => opt.trim().length > 0).length;
}
